import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/** O teto das observações para o motorista — o mesmo da observação do checkout. */
export const MOBILITY_RIDE_NOTES_MAX = 300;

/**
 * Os detalhes da corrida NA CONVERSA (`mobility_ride_details`, #6699): depois
 * da escolha da opção, o telefone do passageiro (obrigatório) e as observações
 * para o motorista (opcionais), no lugar do «alguma preferência?» em texto. O
 * telefone vale só nesta corrida: nunca vai para o perfil de quem viaja.
 * `travelerName` ausente = quem pede é quem viaja. `phone`/`notes` semeiam o
 * campo (o número em ficha, as observações já ditas). O Continuar devolve o
 * challenge com a `MobilityRideDetailsSubmit`.
 */
export const MobilityRideDetailsBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('mobility_ride_details'),
    challengeId: z.string().min(1),
    travelerName: z.string().trim().min(1).max(120).optional(),
    phone: z.string().trim().min(1).max(40).optional(),
    notes: z.string().trim().min(1).max(MOBILITY_RIDE_NOTES_MAX).optional(),
  })
  .strict();
export type MobilityRideDetailsBlock = z.infer<typeof MobilityRideDetailsBlockSchema>;

/** O Continuar do card, ecoado em `interaction.data`: o telefone em E.164
 *  (`+5511987654321`) e as observações, quando há. */
export const MobilityRideDetailsSubmitSchema = z
  .object({
    action: z.literal('mobility_ride_details_submit'),
    phone: z.string().regex(/^\+[1-9]\d{6,14}$/),
    notes: z.string().trim().min(1).max(MOBILITY_RIDE_NOTES_MAX).optional(),
  })
  .strict();
export type MobilityRideDetailsSubmit = z.infer<typeof MobilityRideDetailsSubmitSchema>;
